<template>
  <div class="home-wrap">
    <div
      ref="fullpage"
      class="home"
      @wheel="handleWheel"
      @touchstart.passive="handleTouchStart"
      @touchend.passive="handleTouchEnd"
    >
      <section class="home__section home__section--banner">
        <Banner :banners="homeData.banner" />
      </section>
      <section class="home__section home__section--content home__section--video">
        <div class="home__video-wrap">
          <video class="home__video" :src="homeVideo" controls autoplay muted loop playsinline></video>
        </div>
      </section>
      <section class="home__section home__section--content home__section--highlights">
        <InspectionHighlights />
      </section>
      <section class="home__section home__section--content home__section--news-focus">
        <NewsFocus />
      </section>
      <section class="home__section home__section--footer">
        <Footer compact />
      </section>
    </div>
    <div class="home__dots" v-if="!isMobile">
      <button
        v-for="index in sectionCount"
        :key="index"
        class="home__dot"
        :class="{ active: currentSection === index - 1 }"
        @click="scrollToSection(index - 1)"
      ></button>
    </div>
  </div>
</template>

<script>
import Banner from './home/Banner.vue'
import InspectionHighlights from './home/InspectionHighlights.vue'
import NewsFocus from './home/NewsFocus.vue'
import Footer from './Footer.vue'
import homeVideo from '@/assets/video/test2.mp4'
// import { homeApi } from '../api'
import { mockData } from '../api/mock'

export default {
  name: 'Home',
  components: {
    Banner,
    InspectionHighlights,
    NewsFocus,
    Footer
  },
  data() {
    return {
      homeData: {
        banner: [],
        advantages: [],
        coreBusiness: []
      },
      currentSection: 0,
      sectionCount: 5,
      isAnimating: false,
      isMobile: false,
      touchStartY: 0,
      homeVideo
    }
  },
  mounted() {
    this.fetchHomeData()
    this.checkScreenSize()
    window.addEventListener('resize', this.checkScreenSize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize)
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth < 1024
      if (this.isMobile) {
        this.currentSection = 0
        this.isAnimating = false
      }
    },
    handleWheel(event) {
      if (this.isMobile || this.isAnimating) {
        return
      }

      const currentSection = event.target.closest('.home__section')
      if (currentSection) {
        const canScrollInside = currentSection.scrollHeight > currentSection.clientHeight
        if (canScrollInside) {
          const atTop = currentSection.scrollTop <= 0
          const atBottom = currentSection.scrollTop + currentSection.clientHeight >= currentSection.scrollHeight - 1
          if ((event.deltaY > 0 && !atBottom) || (event.deltaY < 0 && !atTop)) {
            return
          }
        }
      }

      event.preventDefault()
      const direction = event.deltaY > 0 ? 1 : -1
      const targetIndex = this.currentSection + direction
      this.scrollToSection(targetIndex)
    },
    handleTouchStart(event) {
      if (this.isMobile || !event.changedTouches || !event.changedTouches[0]) {
        return
      }
      this.touchStartY = event.changedTouches[0].clientY
    },
    handleTouchEnd(event) {
      if (this.isMobile || !event.changedTouches || !event.changedTouches[0]) {
        return
      }

      const touchEndY = event.changedTouches[0].clientY
      const diff = this.touchStartY - touchEndY
      const threshold = 50

      if (Math.abs(diff) < threshold || this.isAnimating) {
        return
      }

      const direction = diff > 0 ? 1 : -1
      this.scrollToSection(this.currentSection + direction)
    },
    scrollToSection(index) {
      if (this.isMobile) {
        return
      }

      const clampedIndex = Math.max(0, Math.min(index, this.sectionCount - 1))
      if (clampedIndex === this.currentSection && this.isAnimating) {
        return
      }

      const container = this.$refs.fullpage
      if (!container) {
        return
      }

      this.currentSection = clampedIndex
      this.isAnimating = true
      container.scrollTo({
        top: clampedIndex * container.clientHeight,
        behavior: 'smooth'
      })

      window.setTimeout(() => {
        this.isAnimating = false
      }, 700)
    },
    async fetchHomeData() {
      try {
        // const response = await homeApi.getHomeData()
        // if (response.code === 200) {
        //   this.homeData = response.data
        //   if (process.env.NODE_ENV === 'production') {
            this.homeData.banner = mockData.home.banner
            console.log(this.homeData)
        //   }
        // }
      } catch (error) {
        console.error('获取首页数据失败:', error)
        if (process.env.NODE_ENV === 'production') {
          this.homeData.banner = mockData.home.banner
        }
      }
    }
  }
}
</script>

<style scoped>
.home-wrap {
  position: relative;
}

.home {
  width: 100%;
  height: calc(100vh - 60px);
  overflow: hidden;
  scroll-behavior: smooth;
}

.home__section {
  height: calc(100vh - 60px);
  overflow-y: auto;
}

.home__section--banner {
  overflow: hidden;
}

.home__section--content {
  background-color: #fff;
}

.home__section--highlights {
  overflow: hidden;
}

.home__section--news-focus {
  overflow: hidden;
}

.home__section--footer {
  height: 160px;
  min-height: 160px;
  overflow: hidden;
  background: #ffffff;
  border-top: 1px solid #e9ecef;
}

.home__section--video {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: #000;
  overflow: hidden;
}

.home__video-wrap {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.home__video {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #000;
}

.home__dots {
  position: fixed;
  left: 24px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1200;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.home__dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: none;
  background-color: rgba(0, 123, 255, 0.35);
  cursor: pointer;
  transition: all 0.2s ease;
}

.home__dot.active {
  height: 24px;
  border-radius: 8px;
  background-color: #007bff;
}

@media (max-width: 1023px) {
  .home {
    height: auto;
    overflow: visible;
  }

  .home__section {
    height: auto;
    overflow: visible;
  }

  .home__section--banner {
    min-height: 420px;
  }

  .home__section--video {
    padding: 0;
    min-height: 360px;
  }

  .home__section--footer {
    height: auto;
    min-height: 280px;
    overflow: visible;
  }

  .home__video-wrap {
    height: 100%;
  }

  .home__video {
    height: 100%;
    min-height: 360px;
  }
}
</style>
